import { BehaviorSubject } from 'rxjs';
import { TOKEN_TO_DOLLAR_CONFIG } from "../../../config/api";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class DistributionsRatioService {
    constructor(http) {
        this.http = http;
        this.config = TOKEN_TO_DOLLAR_CONFIG;
        this.visible = new BehaviorSubject(null);
    }
    show() {
        this.visible.next(true);
    }
    hide() {
        this.visible.next(false);
    }
    getRatio() {
        return this.http.post(this.config.data, {});
    }
    saveRatio(tokens) {
        return this.http.post(this.config.save, { tokens });
    }
}
DistributionsRatioService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DistributionsRatioService_Factory() { return new DistributionsRatioService(i0.ɵɵinject(i1.HttpClient)); }, token: DistributionsRatioService, providedIn: "root" });
